import doc                        from '@widesk-core/decorators/doc';
import AbstractAdvertisementModel from './AbstractAdvertisementModel';
import { RenderNameProps }        from '@widesk-ui/mixins/ApiModelRenderName';

@doc.urnResource('advertisement')
export default class AdvertisementModel extends AbstractAdvertisementModel {
	public renderName(props?: RenderNameProps<this> & AdvertisementNameProps) {
		return super.renderName(props);
	}

	public getTranslationUrn(lang: LanguageKey): Urn | undefined {
		return this.get(`translations.${lang}.@urn`);
	}
}
